import { observer } from 'mobx-react-lite'
import { useAddNumberFromAppContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/context/useAddNumberFromAppContext'
import { SelectAppAndNumbersCommon } from 'pages/settings/ui/SelectAppAndNumbersCommon/SelectAppAndNumbersCommon'

export const SelectAppAndNumbers = observer(() => {
  const { nextClickHandler, selectAppAndNumbersStore } = useAddNumberFromAppContext()

  return (
    <SelectAppAndNumbersCommon
      store={selectAppAndNumbersStore}
      nextClickHandler={nextClickHandler}
    />
  )
})
